import { ThemeOptions } from "@mui/material";
import merge from "lodash/merge";

export const parseTypography = (
  localTypography?: ThemeOptions["typography"],
  remoteTypography?: Partial<ThemeOptions["typography"]>,
): ThemeOptions["typography"] | undefined => {
  if (!localTypography && !remoteTypography) return undefined;
  return merge(localTypography ?? {}, remoteTypography ?? {});
};
